import { Dropdown, Input, OptionsHelper, Spinner } from "@swivl-mono/ui";
import { DateTime } from "luxon";
import { useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";

import { QuestsDropdown } from "../../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";
import { Member } from "../../../../Models/Member/Member.Current";
import { NavBar } from "../../../../Models/NavBar/NavBar.Model";
import { QuestsModel } from "../../../../Models/Quests/Quests.Model";
import SequencesModel from "../../../../Models/Sequences/SequencesModel";
import Quest from "../../../Quests/Quest/Nodes/Quest.Node";
import { SequenceAdminTools } from "../Components/Sequence.AdminTools";
import { ComponentsForSequenceType } from "../Types/SequencePastDue";

export function SequenceDetailsView() {
  const { sequences, sequenceRecords } = SequencesModel.useState();
  const { quests } = QuestsModel.useState(); // use this to make sure they are loaded before we display
  const sequenceId = useParams<{ sequenceId: string }>().sequenceId;

  useEffect(() => {
    SequencesModel.load(false);
    QuestsModel.loadQuestsList(false);
  }, []);

  useEffect(() => {
    if (sequenceId) {
      SequencesModel.loadSequenceRecordsForSequence(parseInt(sequenceId));
    }
  }, [sequenceId]);

  const sequence = useMemo(() => {
    if (!sequenceId || !sequences) return undefined;
    return sequences[sequenceId];
  }, [sequences, sequenceId]);

  const records = useMemo(() => {
    if (!sequenceId || !sequenceRecords) return [];

    return sequenceRecords[sequenceId] || [];
  }, [sequenceRecords, sequenceId]);

  if (!sequence || !quests)
    return (
      <div className="p-5">
        <label>Sequence Details</label>
        <Spinner />
      </div>
    );

  return (
    <div className="p-5">
      <label>Sequence Details</label>
      <h1>{sequence.name}</h1>
      {sequence && <ComponentsForSequenceType sequence={sequence} />}

      <label className="mt-5">Quest</label>

      <QuestsDropdown
        value={sequence?.questSlug}
        optionSelected={(option) => {
          SequencesModel.updateSequence(sequence.id, { questSlug: option.value }, true);
        }}
      />

      {Member.isSuperAdmin && <SequenceAdminTools sequence={sequence} />}

      <h3 className="mt-5">Records</h3>
      {records.map((record) => (
        <Link key={record.id} to={`/settings/sequences/${sequenceId}/record/${record.id}`}>
          <div className="SequenceRecordListItem rounded-md bg-white p-3 mb-3 hover:bg-orange-100">
            <div className="text-black font-semibold">
              Sent to {record.eventsCreated} users on {DateTime.fromISO(record.createdAt as unknown as string).toFormat("L/d/yy @ t")}{" "}
            </div>
            {record.eventsCreated !== record.numberOfUsers ? (
              <div className="float-right warning">
                Not all users were sent {record.eventsCreated} / {record.numberOfUsers}
              </div>
            ) : null}
          </div>
        </Link>
      ))}
    </div>
  );
}
